import factory from './icon';
import Svg from './glyphs/remove-plain.svg';

export default factory(Svg);
